/* eslint-disable @typescript-eslint/no-explicit-any */
import {Component, Vue} from "vue-property-decorator";
import {UserModule} from '@/store/modules/user'
import {
    getFinanceOrderListByCreatedUserId,
    setFinanceMarketCostStatus
} from '@/api/financial-center'

import {getMessageRemindById, getMessageReviewById, setMessageReviewUserByMessageReviewId} from '@/api/message'
import {menuBtn} from '@/utils/menu_level2_button'
import {delNullProperty} from "@/utils";
import {formatDate} from '@/utils/timeFilter'




@Component({})
export default class MarketCost extends Vue {
    invoiceNumTitle = '订单/回款编号：'  //订单回款编号label
    customerId: number  //客户id
    customerType: string  //客户类型
    marketCooperationId: number  //合作伙伴id
    select = '1'  //回款编号
    options = [
        {label: '客户名称', value: '0'},
        {label: '订单/回款编号', value: '1'},
    ]

    logList = []

    customerNameOrMarketCooperationName = ''



    orderDialog = false  //学生订单列表
    partnersOrderDialog = false  //合作伙伴订单列表
    receivableDialog = false
    orderDialogInputValue = ''
    receivableDialogInputValue = ''
    orderDialogTaleData = []
    receivableDialogTaleData = []
    orderDialogTotal = 0
    receivableDialogTotal = 0
    orderDialogPage = 1
    receivableDialogPage = 1
    orderDialogTableLoading = false
    receivableDialogTableLoading = false
    orderDialogSelectTable = []
    formData = {
        id: '',
        types: '',// 费用类型
        other: '',// 费用类型 --- 输入框
        financeOrderId: '',
        price: '',
        score: '',
        reason: '',  //申请原因
        reward:''
    }
    saveDraftDialogShow = false
    errorDialogShow = false
    isDraft = '0'
    orderId: number = null
    tableRandom = Math.random()
    feeTypeList = [
        {label: '合作顾问额外奖励', value: '0'},
        {label: '中小顾问积分奖励', value: '1'},
        {label: '学生奖学金申请', value: '2'},
        {label: '市场活动费用', value: '3'},
        {label: '其他', value: '4'}
    ] // 费用类型
    operationShow = true
    backMoneyStatus = ''
    showInput: any = false
    type = ""
    status: any
    costId = NaN
    isUpdatedData = '0'
    approval_id: number = null // 审批查看详情id
    approval_type: string = null //审批状态 type 0-审批，1-查看
    reviewStatus: string
    cancelReview = false
    reviewDialog = false
    opinion = '' // 审批意见
    tableDataOrder = []
    types = ''
    loading = false
    activities = []

    get userName() {
        return UserModule.userName
    }



    get directorUserId() {
        return UserModule.userId
    }

    get orderAllPrice() {
        let num = 0
        this.tableDataOrder.forEach(item => num += Number(item.priceOrScore))
        return num
    }

    menuBtn = menuBtn
    formatDate = formatDate


    created() {
        //  获取地址栏里的参数
        const url = window.location.href
        const p = url.split('?')[1]
        const params = new URLSearchParams(p)
        const recordId = params.get('id')
        this.types = this.$route.query.types ? this.$route.query.types as string : ''
        this.getMsgData(recordId)
    }

    async getMsgData(id) {
        this.loading = true
        await getMessageRemindById({id: id}).then((data: any) => {
            this.formData = data.result.messageRemindInfo
            this.logList = data.result.messageRemindInfo.financeMarketCostLogList
            this.formData.reward = (data.result.messageRemindInfo.reward == '非实物') ? '1' : '0'
            this.tableDataOrder = data.result.messageRemindInfo.financeMarketCostDetailList
            this.activities = data.result.messageRemindInfo.messageReviewList
            this.loading = false
        }).catch(err => {
            this.loading = false
        })
    }
    async getMessageReviewById() {
        const data: any = await getMessageReviewById(this.approval_id,this.types)
        this.formData = data.result
        this.logList = data.result.messageReviewLogList
    }

    openReviewDialog(status: number){
        this.status = status
        this.reviewDialog = true
    }
    closeReviewDialog() {
        this.reviewDialog = false
        this.opinion = ''
    }
    reviewDialogConfirm() {
        const newObj = this.formData
        const obj = {
            messageReviewId: this.approval_id,
            status: this.status,
            opinion: this.opinion,
            form: this.status === 1 ? newObj : {}
        }
        setMessageReviewUserByMessageReviewId(obj).then(() => {
            this.$message.success(`审批${this.status === 1 ? '通过' : '驳回'}`)
            setTimeout(() => {
                window.close()
            }, 1500)
        })
    }



    // 订单列表
    choiceOrder(e) {
        this.orderDialog = true
        this.getCustomerNameListByFinanceMarketCost()
        e.target.blur()
    }

    // 合作伙伴、学生列表
    async getCustomerNameListByFinanceMarketCost() {
        const obj = {
            customerName: this.orderDialogInputValue,
            page: this.orderDialogPage,
            limit: 20
        }
        const data: any = await getFinanceOrderListByCreatedUserId(delNullProperty(obj))
        this.orderDialogTaleData = data.financeOrderList
        this.orderDialogTotal = data.allNum
        this.orderDialogTableLoading = false
        this.tableRandom = Math.random()
    }



    getRowKeys(row) {
        return `${row.code}`
    }


    // 订单确认事件
    orderDialogConfirm() {
        this.formData.financeOrderId = this.orderDialogSelectTable[0].id
        this.orderDialog = false
    }


    // 订单列表change
    orderDialogSelectionChange(selectionArr: any[]) {
        this.orderDialogSelectTable = selectionArr
    }

    // 订单
    handleOrderRowClick(row) {
        (this.$refs.orderDialogTable as HTMLFormElement).toggleRowSelection(row)
    }


    orderDialogPageChange(page: number) {
        this.orderDialogPage = page
    }

    receivableDialogPageChange(page: number) {
        this.receivableDialogPage = page
    }

    closePage() {
        window.close()
    }

    changeTypes() {
        this.formData.score = ''
        this.formData.price = ''
    }
    // 撤回审批
    async cancelApproval() {
        await setFinanceMarketCostStatus({ id: Number(this.formData.id), action: '1' })
        this.$message.success('撤销审批成功')
        setTimeout(() => {
            window.close()
        }, 1500);
        this.cancelReview = false
    }
}
